module.exports = __webpack_public_path__ + "static/media/closed-eye-100.847802e0.svg";